import React, { useState, useEffect } from 'react';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';
import ShareButton from '../components/ui/ShareButton';
import './Donaciones.css';

export default function Donaciones() {
  const { logueado } = useAuth();
  const [showModal, setShowModal] = useState(false);
  const [selectedCamp, setSelectedCamp] = useState(null);
  const [modalStep, setModalStep] = useState('options'); // options, manual, success
  const [bankInfo, setBankInfo] = useState({});
  const [comprobante, setComprobante] = useState('');
  const [campanias, setCampanias] = useState([]);
  const [stats, setStats]   = useState({});
  const [monto, setMonto]   = useState({});
  const [loading, setLoading] = useState({});

  useEffect(() => {
    // Cargar Campañas Dinámicas
    api.get('/campanias').then(r => setCampanias(r.data)).catch(()=>{});
    
    // Cargar Estadísticas
    api.get('/donaciones/stats').then(r => {
      const m = {};
      r.data.forEach(s => { m[s._id] = s.total; });
      setStats(m);
    }).catch(() => {});

    // Cargar Datos Bancarios para el modal manual
    api.get('/config').then(r => setBankInfo(r.data)).catch(()=>{});
  }, []);

  const abrirDonacion = (camp) => {
    if (!logueado) return toast.error('Inicia sesión para donar');
    const val = parseInt(monto[camp._id]) || 0;
    if (val < 1) return toast.error('Ingresa un monto válido');
    setSelectedCamp(camp);
    setModalStep('options');
    setShowModal(true);
  };

  const procesarDonacion = async (metodo) => {
    const val = parseInt(monto[selectedCamp._id]);
    setLoading(l => ({ ...l, [selectedCamp._id]: true }));

    try {
      if (metodo === 'stripe') {
        const { data } = await api.post('/pagos/stripe', { monto: val, campana: selectedCamp.titulo });
        if (data.url) {
            window.location.href = data.url;
        } else {
            setModalStep('success'); 
        }
      } else if (metodo === 'mercadopago') {
        const { data } = await api.post('/pagos/mercadopago', { monto: val, campana: selectedCamp.titulo });
        if (data.url) {
            window.location.href = data.url;
        } else {
            setModalStep('success');
        }
      } else if (metodo === 'manual') {
        setModalStep('manual');
      }
    } catch (err) {
      toast.error('Error al iniciar el proceso de pago');
    } finally {
      setLoading(l => ({ ...l, [selectedCamp._id]: false }));
    }
  };

  const finalizeManual = async () => {
    const val = parseInt(monto[selectedCamp._id]);
    try {
        const { data } = await api.post('/donaciones/manual', { monto: val, campana: selectedCamp.titulo });
        if (comprobante) await api.put(`/donaciones/${data._id}/comprobante`, { url: comprobante });
        setModalStep('success');
        setMonto(m => ({ ...m, [selectedCamp._id]: '' }));
        setComprobante('');
    } catch (e) {
        toast.error('Error al registrar transferencia');
    }
  };

  const COLORS = { vacunas: 'var(--d)', rescate: 'var(--r)', alimento: 'var(--vd)', infraestructura: 'var(--a)', otro: '#64748b' };

  return (
    <div className="page-wrap fade-up">
      <div className="sec-title">💰 Campañas activas</div>
      <div className="grid-2">
        {campanias.map(camp => {
          const recaudado = stats[camp.titulo] || 0;
          const pct = Math.min(Math.round((recaudado / camp.meta) * 100), 100);
          const color = COLORS[camp.tipo] || '#7f8c8d';
          
          return (
            <div key={camp._id} className={`card ${camp.urgente ? 'border-[#f5b8b3] bg-rc' : ''}`}>
              <div className={`font-fraunces font-black text-base mb-1 ${camp.urgente ? 'text-r' : 'text-tx'}`}>
                {camp.urgente ? '🚨 ' : ''}{camp.titulo}
              </div>
              <div className="text-xs text-txs font-semibold mb-3">{camp.descripcion}</div>

              <div className="prog-wrap mb-2">
                <div className="prog-fill" style={{ width:`${pct}%`, background: color }} />
              </div>
              <div className="flex justify-between text-xs font-bold mb-3.5">
                <span style={{ color: color }}>${recaudado.toLocaleString()} recaudados</span>
                <span className="text-txs">meta: ${camp.meta.toLocaleString()}</span>
              </div>

              <div className="donate-row">
                <input
                  type="number" min="1" placeholder="Monto ($)"
                  className="f-inp"
                  value={monto[camp._id] || ''}
                  onChange={e => setMonto(m => ({ ...m, [camp._id]: e.target.value }))}
                />
                <button
                  className="btn" style={{ background: color, color:'#fff' }}
                  onClick={() => abrirDonacion(camp)}
                  disabled={loading[camp._id]}
                >
                  {loading[camp._id] ? '...' : camp.urgente ? 'Apoyar' : 'Donar'}
                </button>
              </div>
              {camp.publicId && (
                <div className="card-share-row mt-2">
                  <ShareButton
                    tipo="campana"
                    publicId={camp.publicId}
                    title={`${camp.titulo} — Red Cimarrona`}
                    text={`Apoya esta campaña de Red Cimarrona: ${camp.titulo}`}
                    data={{
                      titulo: camp.titulo,
                      descripcion: camp.descripcion
                    }}
                  />
                </div>
              )}
            </div>
          );
        })}
      </div>

      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal-content donate-modal fade-up" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setShowModal(false)}>✕</button>
            
            {modalStep === 'options' && (
                <>
                    <h3 className="mb-1">💚 Apoya el proyecto</h3>
                    <p className="text-xs text-txs mb-5">Selecciona tu método de contribución preferido</p>
                    
                    <div className="donate-options">
                        <button className="d-opt" onClick={() => procesarDonacion('stripe')}>
                            <div className="d-opt-icon" style={{ background: '#f0f0ff', color: '#635bff' }}>💳</div>
                            <div className="d-opt-body">
                                <span className="d-opt-title">Tarjeta / Apple Pay / Google Pay</span>
                                <span className="d-opt-sub">Procesado seguro vía <strong>Stripe</strong></span>
                            </div>
                            <span className="d-opt-tag stripe">INSTANTÁNEO</span>
                        </button>

                        <button className="d-opt" onClick={() => procesarDonacion('mercadopago')}>
                            <div className="d-opt-icon" style={{ background: '#e0f4ff', color: '#009ee3' }}>🏦</div>
                            <div className="d-opt-body">
                                <span className="d-opt-title">SPEI / Transferencia Bancaria</span>
                                <span className="d-opt-sub">A través de <strong>Mercado Pago</strong></span>
                            </div>
                            <span className="d-opt-tag mercadopago">AUTOMÁTICO</span>
                        </button>

                        <button className="d-opt" onClick={() => procesarDonacion('manual')}>
                            <div className="d-opt-icon" style={{ background: 'var(--vc)', color: 'var(--v)' }}>📄</div>
                            <div className="d-opt-body">
                                <span className="d-opt-title">Depósito en Ventanilla / OXXO</span>
                                <span className="d-opt-sub">Datos de cuenta y validación manual</span>
                            </div>
                            <span className="d-opt-tag directo">DIRECTO</span>
                        </button>
                    </div>
                </>
            )}

            {modalStep === 'manual' && (
                <div className="text-left">
                    <h3 className="mb-4">📄 Transferencia Directa</h3>
                    <div className="card bg-slate-50 border border-slate-200 mb-5">
                        <div className="mb-2.5">
                            <label className="text-[11px] font-bold text-txs block">BANCO</label>
                            <div className="font-semibold">{bankInfo.bancoNombre || 'Cargando...'}</div>
                        </div>
                        <div className="mb-2.5">
                            <label className="text-[11px] font-bold text-txs block">CLABE</label>
                            <div className="font-bold text-lg font-mono text-v">
                                {bankInfo.bancoClabe || '0000 0000 0000 0000 00'}
                            </div>
                        </div>
                        <div>
                            <label className="text-[11px] font-bold text-txs block">BENEFICIARIO</label>
                            <div className="font-semibold">{bankInfo.bancoBeneficiario || 'Red Cimarrona'}</div>
                        </div>
                    </div>

                    <label className="f-lbl">¿Tienes un comprobante? (Opcional)</label>
                    <input 
                        className="f-inp" 
                        placeholder="Pega aquí el folio o link al comprobante..." 
                        value={comprobante}
                        onChange={e => setComprobante(e.target.value)}
                    />

                    <div className="flex gap-2.5 mt-2.5">
                        <button className="btn btn-ghost flex-1" onClick={() => setModalStep('options')}>Atrás</button>
                        <button className="btn btn-v flex-[2]" onClick={finalizeManual}>Confirmar Donativo</button>
                    </div>
                </div>
            )}

            {modalStep === 'success' && (
                <div className="text-center py-5">
                    <div className="text-6xl mb-4">🎉</div>
                    <h2 className="m-0">¡Muchas Gracias!</h2>
                    <p className="opacity-70 mb-6">Tu contribución ha sido registrada. Tu apoyo nos permite seguir rescatando y cuidando a la comunidad cimarrona.</p>
                    <button className="btn btn-v btn-full" onClick={() => setShowModal(false)}>Cerrar</button>
                </div>
            )}
          </div>
        </div>
      )}

      <div className="mt-7">
        <div className="sec-title">¿Cómo funciona una donación?</div>
        <div className="card text-[14px] leading-[1.8] text-txm">
          <p>🔒 Todas las donaciones son registradas en nuestra base de datos y auditadas por el equipo coordinador.</p>
          <p className="mt-2">🏆 Cada donación suma <strong>+30 puntos</strong> a tu ranking comunitario.</p>
          <p className="mt-2">📋 Puedes ver el historial completo de donaciones desde el panel de administración.</p>
          <p className="mt-2">💳 Stripe y Mercado Pago confirman tu donación automáticamente. El método manual requiere validación del administrador.</p>
        </div>
      </div>
    </div>
  );
}
